export const version = "sha2/5.0.9";
//# sourceMappingURL=_version.js.map